import React from "react";
const HistoryPricing = () => {
  return <div>ss</div>;
};

export default HistoryPricing;
